import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const TutorDashboardCalendarSlice = createSlice({
  name: "TutorDashboardCalendarSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    TutorDashboardCalendar: (state) => {
      state.isLoading = true;
    },
    successTutorDashboardCalendar: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureTutorDashboardCalendar: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearTutorDashboardCalendar: (state) => {
      state.data = {};
    },
  },
});

export const {
  TutorDashboardCalendar,
  successTutorDashboardCalendar,
  failureTutorDashboardCalendar,
  clearTutorDashboardCalendar,
} = TutorDashboardCalendarSlice.actions;

export default TutorDashboardCalendarSlice.reducer;
